import { ISale } from "../classes/interfaces";
import { formatBRL } from "./currency.helper";

// Extracted from Order/components/ShareButton.tsx's onClick handler -- this exact
// text/URL-building logic is now shared between ShareButton.tsx (fires on manual
// click) and SaleTerminate/index.tsx (fires automatically on load). Only the
// window.open/win.focus() side effects stay with each caller, since those differ.
export function buildWhatsAppShareUrl(sale: ISale, pathname: string): string {
  let text = encodeURIComponent(`*Pedido feito com MenuChef*`) + "%0A";

  sale.products.forEach((product) => {
    text += `%0A%2A${
      product.amount
    }x%2A%20%2D%20${encodeURIComponent(product.name || "")}`;
  });

  text += `%0A%0A${encodeURIComponent(
    `*Nome:* ${sale.deliveryName || ""}`
  )}`;

  if (sale.deliveryType === "delivery") {
    text += `%0A${encodeURIComponent(
      `*Valor Entrega:* ${formatBRL(sale.tax)}`
    )}`;
  }
  text += `%0A${encodeURIComponent(
    `*Total:* ${formatBRL(sale.total)}`
  )}`;

  if (sale.payments.length === 1) {
    if ((sale.payments[0].changeFor || 0) > 0) {
      text += `%0A%0A${encodeURIComponent("*Levar Cartão:* Não")}`;
      text += `%0A${encodeURIComponent(
        `*Troco para:* ${formatBRL(sale.payments[0].changeFor)}`
      )}%0A`;
    } else if (
      sale.payments[0].name &&
      sale.payments[0].name.trim().toUpperCase() === "DINHEIRO"
    ) {
      text += `%0A%0A${encodeURIComponent("*Levar Cartão:* Não")}`;
    } else {
      text += `%0A%0A${encodeURIComponent("*Levar Cartão:* Sim")}`;
    }
  } else {
    text += `%0A%0A${encodeURIComponent("*Levar Cartão:* Sim")}`;
  }

  text += `%0A%0A${encodeURIComponent(
    "*Link para acompanhar o pedido:*"
  )}%0A`;
  text += `http://menuchef.com.br${pathname}`;

  return `https://wa.me/55${(sale.store.cellPhone || "")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll(" ", "")
    .replaceAll("-", "")}?text=${text}`;
}
